import React from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next';

const useFetchTopGuides = () => {
    const [topGuides, setTopGuides] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const { i18n } = useTranslation();

    const fetchTopGuides = React.useCallback(async () => {

        setIsLoading(true)
        const { REACT_APP_BASE_URL } = process.env
        const token = localStorage.getItem('token');

        try {
            const { data } = await axios.get(
                `${REACT_APP_BASE_URL}/index.php?r=api/destinationguides/top`,
                {
                    headers: {
                        'x-authorization-token': token
                    },
                    params: {
                        lng: i18n.language
                    }
                }
            ) || {}

            setIsLoading(false)
            if (data.length) {
                setTopGuides(data)
            }
        } catch (err) {
            console.error('Error fetching top guides: ', err)
            setIsLoading(false)
        }
    }, [])

    React.useEffect(() => {
        fetchTopGuides()
    }, [fetchTopGuides])

    return {
        topGuides,
        isLoading,
    }
}

export default useFetchTopGuides
